import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "./auth/AuthContext";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import DienstenOverview from "./pages/diensten/DienstenOverview";
import ServicePage from "./pages/diensten/ServicePage";
import CasesOverview from "./pages/cases/CasesOverview";
import CasePage from "./pages/cases/CasePage";
import { TopBar } from "./sections/TopBar";
import { Hero, scrollToSection } from "./sections/Hero";
import { StatsBar } from "./sections/StatsBar";
import { Marquee } from "./sections/Marquee";
import { About } from "./sections/About";
import { Services } from "./sections/Services";
import { NoResult } from "./sections/NoResult";
import { Testimonial } from "./sections/Testimonial";
import { BookCall } from "./sections/BookCall";
import { ContactForm } from "./sections/ContactForm";
import { ClosingCTA } from "./sections/ClosingCTA";
import { Footer } from "./sections/Footer";
import { MobileStickyBar } from "./components/FloatingWidgets";
import { ChatWidget } from "./components/ChatWidget";

function Landing() {
  const location = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const timer = setTimeout(() => scrollToSection(location.state.scrollTo), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="min-h-screen bg-ink text-cream" data-testid="app-root">
      <div className="grain-overlay" aria-hidden="true" />
      <TopBar />
      <main>
        <Hero />
        <StatsBar />
        <Marquee />
        <About />
        <Services />
        <NoResult />
        <Testimonial />
        <BookCall />
        <ContactForm />
        <ClosingCTA />
      </main>
      <Footer />
      <ChatWidget />
      <MobileStickyBar />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/diensten" element={<DienstenOverview />} />
          <Route path="/diensten/:slug" element={<ServicePage />} />
          <Route path="/cases" element={<CasesOverview />} />
          <Route path="/cases/:slug" element={<CasePage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
